import { useState } from "react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Switch } from "./ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { Flame, Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function PromoDialog({ car, onSaved }) {
  const [open, setOpen] = useState(false);
  const existing = car.promo || {};
  const [enabled, setEnabled] = useState(existing.enabled ?? true);
  const [pct, setPct] = useState(existing.weekend_discount_pct ?? 15);
  const [until, setUntil] = useState(existing.boost_until ?? "");
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post(`/cars/${car.car_id}/promo`, {
        enabled, weekend_discount_pct: Number(pct), boost_until: until || null,
      });
      toast.success("Promo saved");
      setOpen(false);
      onSaved?.(data.promo);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid={`promo-btn-${car.car_id}`} className="text-xs flex items-center gap-1.5 text-amber-400 hover:text-amber-300">
          <Flame className="w-3 h-3" /> Promo
        </button>
      </DialogTrigger>
      <DialogContent className="bg-[#131722] border-slate-800 max-w-md" data-testid={`promo-dialog-${car.car_id}`}>
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2 text-white">
            <Flame className="w-5 h-5 text-amber-400" /> Promote {car.model}
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={save} className="space-y-5 mt-3">
          <div className="flex items-center justify-between p-3 rounded-lg bg-slate-900 border border-slate-800">
            <div><Label className="text-base">Promo enabled</Label><p className="text-xs text-slate-500 mt-0.5">Weekend price + boost placement</p></div>
            <Switch checked={enabled} onCheckedChange={setEnabled} data-testid="promo-enabled" />
          </div>
          <div>
            <Label>Weekend discount (%)</Label>
            <Input type="number" min={0} max={50} value={pct} onChange={(e) => setPct(e.target.value)} data-testid="promo-pct" className="bg-slate-900 border-slate-800 mt-1.5" />
            <p className="text-xs text-slate-500 mt-1">Applied to bookings starting Fri/Sat/Sun. 0 to disable.</p>
          </div>
          <div>
            <Label className="flex items-center gap-1.5"><Sparkles className="w-3.5 h-3.5 text-cyan-400" /> Boost placement until</Label>
            <Input type="date" value={until?.slice(0, 10) || ""} onChange={(e) => setUntil(e.target.value ? new Date(e.target.value).toISOString() : "")} data-testid="promo-boost" className="bg-slate-900 border-slate-800 mt-1.5" />
            <p className="text-xs text-slate-500 mt-1">Boosted cars appear first in Browse until this date.</p>
          </div>
          <Button type="submit" disabled={busy} data-testid="promo-save" className="w-full h-11 bg-white text-slate-950 hover:bg-slate-100 font-semibold">
            {busy ? "Saving…" : "Save promo"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
